import axios, { AxiosResponse } from 'axios';
import { getAccessTokenBrowser } from 'helpers/auth';
import { getApiUrl } from './constants';

const REQUEST_TIMEOUT_MS = 10000;
export type AudiencesResult = {
	audiences: [
		{
			name: string;
			id: string;
		},
	];
};

export type RequestHeaders = {
	hostname: string;
	Authorization?: string;
};

export type ActitivyResult = {
	Activity: {
		MemberId: string;
		Type: string;
	};
	Error: string;
};

export type Actitivy = {
	MemberId: string;
	Type: string;
};
export const getAudiencesAdapter = async (hostname: string, impersonateId?: string): Promise<AudiencesResult> => {
	const accessToken = await getAccessTokenBrowser();
	const headers: RequestHeaders = {
		hostname,
	};
	if (accessToken) {
		headers.Authorization = 'Bearer ' + accessToken;
	}
	// The member is derived from the access token server-side. Impersonation travels as a
	// query parameter so the server can authorise it against the allowlist - the same shape
	// arrangementsAdapter and tagBasedNewsAdapter already use.
	let apiUrl = 'Personalization/Audience';
	if (impersonateId) {
		apiUrl += `?impersonateId=${encodeURIComponent(impersonateId)}`;
	}
	const { href } = getApiUrl(apiUrl);
	// Bounded so a hung request cannot strand the profile/audience chain. Without a
	// timeout this waited for the browser default and left audiences unresolved.
	const { data: profiles } = await axios.get<AudiencesResult>(href, { headers: headers, timeout: REQUEST_TIMEOUT_MS });
	return profiles;
};

export const CreateActivityAdapterAuthtoken = async (auth: string, type: string): Promise<AxiosResponse<ActitivyResult>> => {
	const payload = {
		MemberId: null,
		type: type,
	};

	const { href } = getApiUrl('Personalization/Activity');
	return axios.post<ActitivyResult>(href, payload, {
		headers: { Authorization: 'Bearer ' + auth, 'Content-Type': 'application/json' },
	});
};
